import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';

import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { InputFieldFloatingLabel as InputField } from "../../../../../common/custom-form/select-filter.component";
import { MAX_LENGTH } from '../../../../../../constants/external-constants';
import { RechargeInventoryDetailsActions } from '../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';

class AdditionalInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: false
        }
    }

    handleToggle = () =>{
        this.setState(prev => ({isCollapsed: !prev.isCollapsed}))
    }


    render() {
        const { rechargeInventoryDetails, rechargeInventoryDetailsForm, isCreateNew } = this.props;
        const {isCollapsed} = this.state;
        const { translator } = this.props;

        return (
            <div className="control-container">
                
            <CustomDropdown activeDropdown={isCollapsed} toggleActiveState={() => {this.handleToggle()}} label={translator("additional_information", false)} >
                <div className={`add-sim-container detail-page-container details-4-col-container capital-uppercase`}>                   
                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('account_number')}
                        value={rechargeInventoryDetailsForm.additionalInformation.accountNumber}
                        fieldProp='field'
                        maxLength={MAX_LENGTH.limit_255}
                        disabled={true}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('customer_tag')}
                        value={rechargeInventoryDetailsForm.additionalInformation.customerTag}
                        fieldProp='rechargeInventoryDetailsForm.additionalInformation.customerTag'
                        placeholder={`${translator('enter_text_placeholder', false)}`}
                        maxLength={MAX_LENGTH.limit_255}
                    />
                </div>
            </CustomDropdown>
        </div>
        );
    }
}


export default connect(
    state => {
        const { rechargeInventoryDetails, translation } = state;
        const { rechargeInventoryDetailsForm } = state.form;
        return {
            ...translation,
            rechargeInventoryDetails,
            rechargeInventoryDetailsForm
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, RechargeInventoryDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
    })
)(AdditionalInformation);